module.exports = __webpack_public_path__ + "img/business_center.def05a3f.svg";